<div class="header" *ngIf="workOrder$ | async as workOrder">
  <h1>
    {{ "workorder.details.title" | translate }}
  </h1>
  <div class="externalId-container">
    <p class="externalId">
      {{ workOrder.externalId }}
    </p>
    <p class="state">
      {{ translateWorkOrderState((workOrder$ | async)?.workOrderState!) }}
    </p>
  </div>

  <app-workorder-detail-actions
    class="actions"
    [workOrder$]="workOrder$"
  ></app-workorder-detail-actions>

  <div class="workorder-details">
    <ul class="details-tabs">
      <li (click)="changeCurrentTab('Description')">
        <span [ngClass]="{ active: (currentTab$ | async) === 'Description' }">
          <mat-icon [inline]="true" class="menu-icon">view_headline</mat-icon>
          <b>{{ "workorder.details.details" | translate }}</b>
        </span>
      </li>
      <li
        (click)="changeCurrentTab('Visits')"
        *ngIf="employeeVisitsIsVisible$ | async"
      >
        <span [ngClass]="{ active: (currentTab$ | async) === 'Visits' }">
          <mat-icon [inline]="true" class="menu-icon">access_time</mat-icon>
          <b>{{ "workorder.details.visits" | translate }}</b>
        </span>
      </li>
      <li
        (click)="changeCurrentTab('AttachedFiles')"
        *ngIf="attachedFilesIsVisible$ | async"
      >
        <span [ngClass]="{ active: (currentTab$ | async) === 'AttachedFiles' }">
          <mat-icon [inline]="true" class="menu-icon">file_copy</mat-icon>
          <b>{{ "workorder.details.attached-files" | translate }}</b>
        </span>
      </li>
    </ul>

    <section class="details-content">
      <app-workorder-badge class="badge" [workOrder$]="workOrder$">
      </app-workorder-badge>

      <article
        class="content-item"
        [ngClass]="{
          'content-active': (currentTab$ | async) === 'Description'
        }"
      >
        <h3>{{ "workorder.details.date" | translate }}</h3>
        <p>
          <strong> {{ "workorder.details.date-expected" | translate }}:</strong>
          {{ workOrder.expectedDate | localizedDate : "dd MMMM, yyyy" }}
        </p>

        <h3>{{ "workorder.details.client" | translate }}</h3>
        <p>
          <strong>{{ "workorder.details.client-name" | translate }}:</strong>
          {{ workOrder.clientName }}
        </p>
        <p>
          <strong>{{ "workorder.details.client-address" | translate }}:</strong>
          {{ workOrder.clientAddress }}
        </p>
        <p *ngIf="attachedFilesIsVisible$ | async">
          <strong>Signed by:</strong> {{ workOrder.clientSignerName }}
        </p>

        <h3>{{ "workorder.details.team" | translate }}</h3>
        <p *ngIf="employeeTeam$ | async; else noTeam">
          {{ employeeTeam$ | async }}
        </p>
        <ng-template #noTeam>
          <p>{{ "workorder.details.no-team" | translate }}</p>
        </ng-template>

        <p *ngIf="attachedFilesIsVisible$ | async">
          <strong>Signed by:</strong> {{ workOrder.employeeSignerName }}
        </p>

        <h3>{{ "workorder.details.description" | translate }}</h3>
        <p>
          {{ workOrder.description }}
        </p>
      </article>

      <article
        *ngIf="employeeVisitsIsVisible$ | async"
        class="content-item"
        [ngClass]="{ 'content-active': (currentTab$ | async) === 'Visits' }"
      >
        <app-employee-visits-details
          [employeeVisitsDetail$]="employeeVisitsDetail$"
        ></app-employee-visits-details>
      </article>

      <article
        class="content-item"
        *ngIf="attachedFilesIsVisible$ | async"
        [ngClass]="{
          'content-active': (currentTab$ | async) === 'AttachedFiles'
        }"
      >
        <p
          class="no-attachedFiles"
          *ngIf="
            (attachedFiles$ | async)?.length == 0 &&
              (previouslyAttachedFiles$ | async)?.length == 0;
            else showFiles
          "
        >
          {{ "workorder.details.no-attached-files" | translate }}
        </p>

        <ng-template #showFiles>
          <app-attached-files-details
            *ngIf="(attachedFiles$ | async)!.length > 0"
            [attachedFiles$]="attachedFiles$"
            [isPreviouslyAttachedFile]="false"
          >
          </app-attached-files-details>

          <app-attached-files-details
            *ngIf="(previouslyAttachedFiles$ | async)!.length > 0"
            [attachedFiles$]="previouslyAttachedFiles$"
            [isPreviouslyAttachedFile]="true"
          >
          </app-attached-files-details>
        </ng-template>
      </article>
    </section>
  </div>
</div>
